
import eService from "../services/eServiceDataService";

export default {
  name: 'DirectorySearch',
  watch: {
    '$store.state.language': function() {
      this.lang = this.$store.state.language;
      this.updateData();
    }
  },
  created() {
    this.loading = true;
    document.title = "Manulife Insurances Directory";

    this.env = this.$store.state.env;
  },
  computed: {

  },
  mounted: async function () {

    await eService.getManulifeHealthcare().then(res => {
      this.apiData = res.data.recordset;
      this.updateData();
      this.loading = false;
    }).catch(e => {
      console.log(e);
    });

  },
  data () {
    return {
      env : '',
      separator: 'vertical',
      filter: '',
      pagination: {
        page: 0,
        rowsPerPage: 0
      },
      columns: [],
      apiData : [],
      data: [],
      source : {},
      lang : this.$store.state.language,
      loading: false,
      errorDialog: false,
      errorMessage: "",
      errorDialogBtn: "",
      title : "",
      pageCookie : JSON.parse(localStorage.getItem('pages')),
      remarks : ""
    }
  },
  methods: {
    readDoc(event, row){

      console.log(row);

      var pdf = row.pdf;

      //var path = (process.env.VUE_APP_ENV === 'prod' ? '/' : (process.env.VUE_APP_ENV === 'local' ? '/' : '/'))
      var pdfUrl = './pdf/manulife/'+pdf+'.pdf';

      var xhr = new XMLHttpRequest()
      xhr.open('HEAD', pdfUrl, false)
      xhr.send()

      if(xhr.status == '404'){
        alert('File is not existed. Please help to check with IT')
      }else{
        //this.$router.push({ name: 'ReadPDF', params: { pdf: pdfUrl } })
        window.open(pdfUrl, '_blank')
      }

    },
    updateData(){

      //console.log(this.apiData);

      this.data = [];
      this.title = (this.pageCookie)[3]["name_"+this.lang];
      this.remarks = (this.pageCookie)[3]["remarks_"+this.lang];

      this.columns = [
        {
          name : "label",
          field : "label",
          label :  this.title,
          align: 'left',
          sortable: true
        }
      ];

      this.apiData.forEach(item => {
        this.data.push(
          {
            label : item['name_'+this.lang],
            pdf : item.contractCode,
            align: 'center',
            sortable: true
          }
        )
      });


    }
  }
}
